import { Fragment } from 'react';
import { LayoutBuilder } from '~/rage/utils';
import { Layouts } from '~/shared';
import { Background } from './components/Background';
import { CatchRing } from './views/CatchRing';

const LayoutComponent = () => (
	<Fragment>
		<Background />
		<CatchRing />
	</Fragment>
);

const Layout = new LayoutBuilder(LayoutComponent)
	.setDisplayName(Layouts.CatchRing)
	.setHudVisible(true)
	.build();

export default Layout;
